import { z } from "zod";

/** Request body for the private admin organization creation endpoint. */
export const CreateOrganizationRequestSchema = z.object({
  name: z.string().trim().min(1),
  emails: z.array(z.string().trim().email()),
});

export type CreateOrganizationRequest = z.infer<
  typeof CreateOrganizationRequestSchema
>;

/** Organization returned after it is created in WorkOS and Forgepoint. */
export const CreatedOrganizationSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string().nullable(),
  externalId: z.string().nullable(),
});

export type CreatedOrganization = z.infer<typeof CreatedOrganizationSchema>;

/** An invitation that could not be sent, with the reason it failed. */
export const InvitationFailureSchema = z.object({
  email: z.string(),
  error: z.string(),
});

export type InvitationFailure = z.infer<typeof InvitationFailureSchema>;

/** Response for POST /admin/organizations. */
export const CreateOrganizationResponseSchema = z.object({
  organization: CreatedOrganizationSchema,
  invited: z.array(z.string()),
  failed: z.array(InvitationFailureSchema),
});

export type CreateOrganizationResponse = z.infer<
  typeof CreateOrganizationResponseSchema
>;
